import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAboutFaqIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10.5,
			fill: "white",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6562 11.8444C13.0815 12.197 12.7418 12.6035 12.5893 13.186C12.4741 13.6262 12.1262 14 11.6712 14C11.2114 14 10.8296 13.6236 10.8863 13.1673C11.0335 11.9812 11.5063 11.4417 12.2343 10.9893C12.8358 10.6115 13.2982 10.1342 13.2982 9.43819C13.2982 8.65765 12.6867 8.15055 11.926 8.15055C11.4699 8.15055 11.0242 8.34004 10.7562 8.73C10.486 9.12319 10.1291 9.53265 9.65203 9.53265C9.14912 9.53265 8.72791 9.10858 8.87907 8.62893C9.28638 7.33641 10.4994 6.67896 11.936 6.67896C13.8351 6.67896 15.1427 7.73293 15.1427 9.41333C15.1427 10.5518 14.5709 11.2976 13.6562 11.8444Z",
			fill: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.801 16.0156C12.7961 16.6221 12.2939 17.1094 11.7073 17.1094C11.1008 17.1094 10.6086 16.6221 10.6135 16.0156C10.6086 15.419 11.1008 14.9318 11.7073 14.9318C12.2939 14.9318 12.7961 15.419 12.801 16.0156Z",
			fill: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledAboutFaqIcon);
const Memo = memo(ForwardRef);
export default Memo;
